import type { SearchFormQuery } from '@travel/traveler-core/types/providerList';

export function getDataLayerPageName(query?: SearchFormQuery): string {
  return query?.startDate || query?.endDate
    ? 'search:search_results_dated_list'
    : 'search:search_results_undated_list';
}
